module.exports = __webpack_public_path__ + "img/23.d2afbb43.jpg";